import { usePricingSeasonal } from '@hooks/use-pricing-seasonal';
import { TextBody } from '@tkww/orion-web-ds-text';
import React, { useMemo } from 'react';
import type { SeasonType } from '../..';
import { getSeasonRangeLabels } from '../../utils/season';
import Styles from './styles.scss';

interface SeasonDescriptorProps {
	selectedSeason: SeasonType;
}

export const SeasonDescriptor = ({ selectedSeason }: SeasonDescriptorProps) => {
	const { peakMonths, offPeakMonths } = usePricingSeasonal();

	const seasonInfo = useMemo(() => {
		const targetMonths = selectedSeason === 'peak' ? peakMonths : offPeakMonths;
		const labels = getSeasonRangeLabels(targetMonths);

		return {
			...labels,
			displayLabel: selectedSeason === 'peak' ? 'Peak' : 'Off-peak',
		};
	}, [selectedSeason, peakMonths, offPeakMonths]);

	if (!seasonInfo.formattedRange) return null;

	return (
		<TextBody
			size="xs"
			color="subtle-dark"
			data-testid="season-descriptor"
			className={Styles.seasonDescriptor}
			key={selectedSeason}
		>
			{`${seasonInfo.displayLabel} season for this venue is ${seasonInfo.formattedRange}.`}
		</TextBody>
	);
};
